import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faAlarmExclamation } from '@fortawesome/pro-solid-svg-icons/faAlarmExclamation'
import { faCalendarStar } from '@fortawesome/pro-solid-svg-icons/faCalendarStar'
import { LearningPathStatus } from 'enum/learningPathStatus.enum'
import { CourseStateType } from 'enum/course-state.enum'
import { State } from './styled'

export const learningPathStates = [
  {
    id: LearningPathStatus.draft,
    name: 'Borrador',
    color: '#D9D9D9',
    icon: <FontAwesomeIcon icon={faPen} />,
    component: (
      <State color="#D9D9D9" height={28}>
        <FontAwesomeIcon icon={faPen} />
        Borrador
      </State>
    ),
  },
  {
    id: LearningPathStatus.published,
    name: 'Publicado',
    color: '#00B47C',
    icon: <FontAwesomeIcon icon={faCheckCircle} />,
    component: (
      <State color="#00B47C" height={28}>
        <FontAwesomeIcon icon={faCheckCircle} />
        Publicado
      </State>
    ),
  },
]

export const courseStates = [
  {
    id: CourseStateType.Draft,
    name: 'Borrador',
    color: '#D9D9D9',
    icon: <FontAwesomeIcon icon={faPen} />,
    component: (
      <State color="#D9D9D9" height={32}>
        <FontAwesomeIcon icon={faPen} />
        Borrador
      </State>
    ),
  },
  {
    id: CourseStateType.Published,
    name: 'Publicado',
    color: '#00B47C',
    icon: <FontAwesomeIcon icon={faCheckCircle} />,
    component: (
      <State color="#00B47C" height={32}>
        <FontAwesomeIcon icon={faCheckCircle} />
        Publicado
      </State>
    ),
  },
  {
    id: CourseStateType.Soon,
    name: 'Programado',
    color: '#FFC500',
    icon: <FontAwesomeIcon icon={faCalendarStar} />,
    component: (
      <State color="#FFC500" height={32}>
        <FontAwesomeIcon icon={faCalendarStar} />
        Programado
      </State>
    ),
  },
  {
    id: CourseStateType.Imparted,
    name: 'Impartido',
    color: '#9ECFFA',
    icon: <FontAwesomeIcon icon={faAlarmExclamation} />,
    component: (
      <State color="#9ECFFA" height={32}>
        <FontAwesomeIcon icon={faAlarmExclamation} />
        Impartido
      </State>
    ),
  },
]
